import React from "react";

/**
 * DOSSIÊ BRASIL badge logo — fully original.
 * Geometric archival badge: hex outline, central tri-stripe document mark,
 * typographic rings. Black + crimson + offwhite.
 */
export default function Logo({ className = "h-9 w-9", withText = true }) {
  return (
    <div className={`flex items-center gap-3 ${withText ? "" : ""}`}>
      <svg
        viewBox="0 0 64 64"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <polygon
          points="32,3 58,17 58,47 32,61 6,47 6,17"
          stroke="#f4f4f5"
          strokeWidth="1.2"
          fill="#0a0a0a"
        />
        <polygon
          points="32,8 54,20 54,44 32,56 10,44 10,20"
          stroke="#dc2626"
          strokeWidth="1"
          fill="none"
        />
        {/* Document bars */}
        <rect x="22" y="22" width="20" height="3" fill="#f4f4f5" />
        <rect x="22" y="29" width="20" height="3" fill="#dc2626" />
        <rect x="22" y="36" width="14" height="3" fill="#f4f4f5" />
        {/* Cross-corner red registration marks */}
        <path d="M8 8 L14 8 M8 8 L8 14" stroke="#dc2626" strokeWidth="1" />
        <path d="M56 8 L50 8 M56 8 L56 14" stroke="#dc2626" strokeWidth="1" />
        <path d="M8 56 L14 56 M8 56 L8 50" stroke="#dc2626" strokeWidth="1" />
        <path d="M56 56 L50 56 M56 56 L56 50" stroke="#dc2626" strokeWidth="1" />
      </svg>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-[15px] font-semibold tracking-wider text-neutral-100">
            DOSSIÊ BRASIL
          </div>
          <div className="font-mono text-[9px] tracking-[0.3em] text-red-500 mt-1">
            ARQUIVO · INDEPENDENTE
          </div>
        </div>
      )}
    </div>
  );
}
